<script setup>
import { computed } from 'vue'

const props = defineProps({
  item: {
    type: Object,
    required: true
  }
})

const emit = defineEmits(['select'])

const taxPercentage = computed(() => {
  return (parseFloat(props.item.taxRate) * 100).toFixed(0)
})

const handleSelect = () => {
  emit('select', props.item.price.id, props.item._discountId || null)
}

</script>

<template>
  <q-card>
    <q-card-section class="row items-center justify-between no-wrap">
      <div class="text-h6 text-weight-bold text-ellipsis">
        {{ item.product.name }}
      </div>

      <q-chip
        v-if="item.discounts && item.discounts.length > 0"
        dense
        square
        color="primary"
        text-color="white"
      >
        -{{ item.discounts[0].discount.amount }}%
      </q-chip>
    </q-card-section>

    <q-card-section>
      <div class="text-body2 text-grey-8">
        {{ $t(item.product.description || 'subscriptions.noDescription') }}
      </div>

      <div
        v-if="item.price.customData && item.price.customData.max_messages"
        class="text-body2 text-grey-7 q-mt-sm"
      >
        {{ $t('subscriptions.maxMessages') }}: {{ item.price.customData.max_messages }}
      </div>

      <q-list dense>
        <q-item>
          <q-item-section class="text-body2 text-grey-7">
            {{ $t('subscriptions.basePrice') + ' (' + item.quantity + ' ' + $t('subscriptions.units') + ')' }}
          </q-item-section>
          <q-item-section
            side
            class="text-body2 text-strike text-grey-6"
          >
            {{ item.formattedTotals.subtotal }}
          </q-item-section>
        </q-item>

        <q-item v-if="item.totals.discount > 0">
          <q-item-section class="text-body2 text-positive text-weight-bold">
            {{ $t('subscriptions.discount') }}
          </q-item-section>
          <q-item-section
            side
            class="text-body2 text-positive text-weight-bold"
          >
            - {{ item.formattedTotals.discount }}
          </q-item-section>
        </q-item>

        <q-item>
          <q-item-section class="text-body2 text-grey-7">
            {{ $t('subscriptions.taxRate') }} {{ taxPercentage }}%
          </q-item-section>
          <q-item-section
            side
            class="text-body2 text-weight-medium"
          >
            {{ item.formattedTotals.tax }}
          </q-item-section>
        </q-item>

        <q-separator class="q-my-md" />

        <q-item>
          <q-item-section>
            <div class="text-h6 text-weight-bolder text-uppercase text-grey-9">
              {{ $t('subscriptions.total') }}
            </div>
          </q-item-section>
          <q-item-section
            side
            class="text-h5 text-weight-bolder text-primary"
          >
            {{ item.formattedTotals.total }}
          </q-item-section>
        </q-item>
      </q-list>
    </q-card-section>

    <q-card-section>
      <div class="text-caption text-grey-6">
        {{ $t('subscriptions.cardRequiredInfo') }}
      </div>
    </q-card-section>

    <q-card-actions align="center">
      <q-btn
        color="primary"
        outline
        class="text-weight-bold"
        :label="$t('subscriptions.selectPlan')"
        @click.stop="handleSelect"
      />
    </q-card-actions>
  </q-card>
</template>

